import type { PageNames } from "@libs/acp/common/types/accessPermissions";

export const pageNames: PageNames = {
	home: { path: "/", type: "public", name: "Home" },
	signin: { path: "/login", type: "public", name: "Login" },
	testeIframe: { path: "/teste-iframe", type: "public", name: "Teste Iframe" },
	signup: { path: "/cadastro", type: "public", name: "Cadastro" },
	signUpNCAD: {
		path: "/negociacao-simplificada",
		type: "public",
		name: "Negociação Simplificada",
	},
	signupNCADCompleted: {
		path: "/cadastro-ncad-completo",
		type: "public",
		name: "Cadastro NCAD Completo",
	},
	signUpPartnerCompleted: {
		path: "/cadastro-via-parceiro-completo",
		type: "public",
		name: "Cadastro via Parceiro Completo",
	},
	signupACPErrorKBA: {
		path: "/cadastro/erro-informacoes",
		type: "public",
		name: "Cadastro",
	},
	signupACPBlockedKBA: {
		path: "/cadastro/falha-ao-validar-informacoes",
		type: "public",
		name: "Cadastro",
	},
	signupACPBlockedLGPD: {
		path: "/cadastro/bloqueio-de-seguranca",
		type: "public",
		name: "Cadastro",
	},
	recoveryPasswordACPInvalidKBA: {
		path: "/recuperar-senha/erro-informacoes",
		type: "public",
		name: "Recuperar Senha",
	},
	recoveryPasswordACPBlockedKBA: {
		path: "/recuperar-senha/falha-ao-validar-informacoes",
		type: "public",
		name: "Recuperar Senha",
	},
	resetPasswordACPInvalidKBA: {
		path: "/redefinir-senha/erro-informacoes",
		type: "public",
		name: "Redefinir Senha",
	},
	resetPasswordACPBlockedKBA: {
		path: "/redefinir-senha/falha-ao-validar-informacoes",
		type: "public",
		name: "Redefinir Senha",
	},
	signinACPFailedDocument: {
		path: "/falha-ao-validar-documento",
		type: "public",
		name: "Login",
	},
	recoveryPassword: {
		path: "/recuperar-senha",
		type: "public",
		name: "Recuperar Senha",
	},
	redefinePassword: {
		path: "/redefinir-senha",
		type: "public",
		name: "Redefinir Senha",
	},
	validateConflictingEmailACP: {
		path: "/validar-contato/email",
		type: "public",
		name: "Validar Email",
	},
	publicEmailConfirmation: {
		path: "/confirmacao-de-email",
		type: "public",
		name: "Confirmar Email",
	},
	accountCanceled: {
		path: "/conta-cancelada",
		type: "public",
		name: "Conta Cancelada",
	},
	notFound: {
		path: "/pagina-nao-encontrada",
		type: "public",
		name: "Página não encontrada",
	},
	account: {
		path: "/minha-conta",
		type: "private",
		name: "Minha conta",
		permissionsToAccess: ["all", "customer"],
	},
	debts: {
		path: "/dividas",
		type: "private",
		name: "Dívidas",
		permissionsToAccess: [
			"all",
			"reneg",
			"reneg:read:agreements",
			"reneg:feature:renegociate",
		],
	},
	myDebts: {
		path: "/minhas-dividas",
		type: "private",
		name: "Minhas dívidas",
		permissionsToAccess: [
			"all",
			"renegociate_debts",
			"read_debts",
			"reneg",
			"reneg:read:debts",
			"reneg:read:agreements",
			"reneg:feature:renegociate",
		],
	},
	updateEmailACP: {
		path: "/atualizar-contato/email",
		type: "private",
		name: "Atualizar Email",
		permissionsToAccess: ["all", "customer", "customer:write:data"],
		fullScreen: true,
	},
	updatePhoneACP: {
		path: "/atualizar-contato/telefone",
		type: "private",
		name: "Atualizar Telefone",
		permissionsToAccess: ["all", "customer", "customer:write:data"],
		fullScreen: true,
	},
	updateSocialName: {
		path: "/atualizar-nome-social",
		type: "private",
		name: "Atualizar Nome Social",
		permissionsToAccess: ["all", "customer", "customer:write:data"],
		fullScreen: true,
	},
	updateContactSuccess: {
		path: "/atualizar-contato/sucesso",
		type: "private",
		name: "Contato atualizado com sucesso",
		permissionsToAccess: ["all", "customer", "customer:write:data"],
		fullScreen: true,
	},
	updatePasswordACP: {
		path: "/alterar-senha",
		type: "private",
		name: "Alterar Senha",
		permissionsToAccess: ["all", "customer", "customer:write:data"],
		fullScreen: true,
	},
	updatePasswordSuccess: {
		path: "/alterar-senha/sucesso",
		type: "private",
		name: "Senha alterada com sucesso",
		permissionsToAccess: ["all", "customer", "customer:write:data"],
		fullScreen: true,
	},
	signinUnifyPasswordACP: {
		path: "/unificar-senha",
		type: "private",
		name: "Unificar Senha",
		permissionsToAccess: ["all", "customer", "customer:write:data"],
		fullScreen: true,
	},
	confirmation: {
		path: "/:partner/confirmacao",
		type: "private",
		name: "Confirmação",
		permissionsToAccess: [
			"all",
			"renegociate_debts",
			"reneg",
			"reneg:feature:renegociate",
		],
	},
	agreementClosed: {
		path: "/:partner/acordo-fechado",
		type: "private",
		name: "Acordo Fechado",
		permissionsToAccess: [
			"all",
			"renegociate_debts",
			"reneg",
			"reneg:feature:renegociate",
		],
	},
	agreementClosedError: {
		path: "/:partner/acordo-fechado/erro",
		type: "private",
		name: "Erro ao fechar o acordo",
		permissionsToAccess: [
			"all",
			"renegociate_debts",
			"reneg",
			"reneg:feature:renegociate",
		],
	},
	billetNotFoundError: {
		path: "/boleto-nao-encontrado",
		type: "private",
		name: "Erro ao baixar o boleto",
		permissionsToAccess: ["all", "reneg", "reneg:feature:renegociate"],
	},
	offers: {
		path: "/ofertas",
		type: "private",
		name: "Ofertas",
		permissionsToAccess: ["all", "credit"],
	},
	offerAnalysis: {
		path: "/analisando-oferta",
		type: "private",
		name: "Analisando Oferta",
		permissionsToAccess: ["all", "credit"],
	},
	loans: {
		path: "/emprestimos",
		type: "private",
		name: "Simulador de Empréstimo",
		permissionsToAccess: ["all", "credit"],
	},
	myAgreements: {
		path: "/meus-acordos",
		type: "private",
		name: "Meus Acordos",
		permissionsToAccess: [
			"all",
			"renegociate_debts",
			"read_debts",
			"read_agreements",
			"reneg",
			"reneg:read:debts",
			"reneg:read:agreements",
			"reneg:feature:renegociate",
		],
	},
	myAgreementsDetail: {
		path: "/meus-acordos/acordo/:agreementId",
		type: "private",
		name: "Detalhe do Acordo",
		permissionsToAccess: [
			"all",
			"renegociate_debts",
			"read_debts",
			"read_agreements",
			"reneg",
			"reneg:read:debts",
			"reneg:read:agreements",
			"reneg:feature:renegociate",
		],
	},
	myAgreementsDetailConditions: {
		path: "/meus-acordos/acordo/:agreementId/condicoes",
		type: "private",
		name: "Condições do Acordo",
		permissionsToAccess: [
			"all",
			"renegociate_debts",
			"read_debts",
			"reneg",
			"reneg:read:debts",
			"reneg:read:agreements",
			"reneg:feature:renegociate",
		],
	},
	myAgreementsDetailCompositions: {
		path: "/meus-acordos/acordo/:agreementId/composicao",
		type: "private",
		name: "Composição do Acordo",
		permissionsToAccess: [
			"all",
			"renegociate_debts",
			"read_debts",
			"reneg",
			"reneg:read:debts",
			"reneg:read:agreements",
			"reneg:feature:renegociate",
		],
	},
	negativeDebts: {
		path: "/debitos-negativados",
		type: "private",
		name: "Dívidas Negativadas",
		permissionsToAccess: [
			"all",
			"renegociate_debts",
			"read_debts",
			"reneg",
			"reneg:read:debts",
			"reneg:read:agreements",
			"reneg:feature:renegociate",
		],
	},
	myScore: {
		path: "/monitoramento/financeiro",
		type: "private",
		name: "Financeiro",
		permissionsToAccess: [
			"all",
			"score",
			"score:read:score",
			"score:read:positive_data",
		],
	},
	scoreKbaQuestions: {
		path: "/monitoramento/score",
		type: "private",
		name: "Score",
		permissionsToAccess: [
			"all",
			"score",
			"score:read:score",
			"score:read:positive_data",
		],
	},
	scoreError: {
		path: "/monitoramento/erro",
		type: "private",
		name: "Score Error",
		permissionsToAccess: [
			"all",
			"score",
			"score:read:score",
			"score:read:positive_data",
		],
	},
	accountDeletion: {
		path: "/minha-conta/deletar-conta",
		type: "private",
		name: "Deletar conta",
		permissionsToAccess: ["all", "customer"],
	},
	details: {
		path: "/oferta-detalhada/:slug",
		type: "private",
		name: "Oferta Detalhada",
		permissionsToAccess: ["all", "credit"],
	},
	cpfLookout: {
		path: "/consultas-cpf",
		type: "private",
		name: "Consultas CPF",
		permissionsToAccess: ["all", "score", "score:read:positive_data"],
	},
	cpfAlert: {
		path: "/alerta-cpf",
		type: "private",
		name: "Alerta CPF",
		permissionsToAccess: ["all", "score", "score:read:score"],
	},
	activityHistory: {
		path: "/alerta-cpf/historico",
		type: "private",
		name: "Histórico de Atividades",
		permissionsToAccess: ["all", "score", "score:read:score"],
	},
	billsAndPayments: {
		path: "/contas-pagamentos",
		type: "private",
		name: "Cadastro Positivo",
		permissionsToAccess: ["all", "score", "score:read:positive_data"],
	},
	contactUs: {
		path: "/fale-conosco",
		type: "public",
		name: "Fale Conosco",
	},
	unlockProtectedFeature: {
		path: "/validar-identidade",
		type: "private",
		name: "Validar identidade",
		fullScreen: true,
		permissionsToAccess: [
			"reneg",
			"reneg:read:debts",
			"reneg:read:agreements",
			"reneg:feature:renegociate",
			"score",
			"score:read:score",
			"score:read:hidden_score",
			"score:read:positive_data",
			"credit",
			"customer",
			"customer:read:data",
			"customer:write:data",
		],
	},
	unlockProtectedFeatureSuccess: {
		path: "/validar-identidade/sucesso",
		type: "private",
		name: "Identidade validada com sucesso",
		permissionsToAccess: ["all"],
		fullScreen: true,
	},
	unlockProtectedFeaturePassword: {
		path: "/validar-identidade/recuperar-senha",
		type: "private",
		name: "Recuperar Senha",
		fullScreen: true,
		permissionsToAccess: [
			"score",
			"score:read:score",
			"score:read:hidden_score",
			"score:read:positive_data",
			"customer",
			"customer:read:data",
			"customer:write:data",
		],
	},
	unlockProtectedFeatureACPInvalidKBA: {
		path: "/validar-identidade/recuperar-senha/erro-informacoes",
		type: "private",
		name: "KBA inválido",
		permissionsToAccess: ["all"],
		fullScreen: true,
	},
	unlockProtectedFeatureACPBlockedKBA: {
		path: "/validar-identidade/recuperar-senha/falha-ao-validar-informacoes",
		type: "private",
		name: "Falha ao validar informações",
		permissionsToAccess: ["all"],
		fullScreen: true,
	},
	mfaPositiveData: {
		path: "/validar-identidade/cadastro-positivo",
		type: "private",
		name: "Cadastro Positivo",
		permissionsToAccess: ["all"],
		fullScreen: true,
	},
};

export const publicPagePaths = Object.keys(pageNames).reduce(
	(acc: string[], curr: string) =>
		pageNames[curr].type === "public" ? acc.concat(pageNames[curr].path) : acc,
	[],
);

export const privatePagePaths = Object.keys(pageNames).reduce(
	(acc: string[], curr: string) =>
		pageNames[curr].type === "private" ? acc.concat(pageNames[curr].path) : acc,
	[],
);

export const pagePaths = Object.keys(pageNames).map((key) => ({
	path: pageNames[key].path,
}));

export const fullScreenPagePaths = Object.keys(pageNames).reduce(
	(acc: string[], curr: string) =>
		pageNames[curr].fullScreen ? acc.concat(pageNames[curr].path) : acc,
	[],
);
